
export default {
    methods:{
        dateFormatterForDatePicker(dt){
            //de-DE  en-GB
            // console.log('test  en-GB')
            return dt.toLocaleDateString('en-GB');
        }
    },
}